"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SWITCHBOARD_V2_IDL = void 0;
var switchboard_v2_1 = require("./switchboard_v2");
Object.defineProperty(exports, "SWITCHBOARD_V2_IDL", { enumerable: true, get: function () { return switchboard_v2_1.IDL; } });
